import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '审读系统';
const baseUrl = '0420BMB';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/login`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Modify',
      name: `${baseUrl}-Modify`,
      component: () => import('./pages/Modify.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'login',
      name: `${baseUrl}-login`,
      component: () => import('./pages/Login.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'much',
      name: `${baseUrl}-much`,
      component: () => import('./pages/Much.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'hostpot',
      name: `${baseUrl}-hostpot`,
      component: () => import('./pages/Hostpot.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
